/**
 * 上传地址
 */
export const OSSUrl = () => {
  return 'https://zgsm.zhongguangshimei.com/';
};
/**
 * 人生相册本地URL
 */
export const localUrl = () => {
  return 'http://127.0.0.1:8890/';
};
export const updataLink = () => {
  //return 'test/'; //测试
  //return 'train/'; //训练
  return 'product/'; //正式
};

/**
 * 切换版本
 */
 export const environment = () => {
  //家书
  return true;
  //训练
  //return false;
};

export const perspnalLink = () => {
  //return 'wss://test.manager.zhongguangshimei.com'; //测试
  //return 'wss://train.manager.zhongguangshimei.com'; //训练
  return 'wss://manager.zhongguangshimei.com'; //正式
};


/**
 * @desc 异常捕获
 * @param fn 回调函数
 * @returns null||err
 */
export const catchErr = promise => {
  return promise
    .then(function () {
      return [null, ...arguments]
    })
    .catch(err => {
      return [err, null]
    })
}


/**
 * @desc 判断系统类型
 * @returns true||false
 */
export const OSnow = () => {
  var agent = navigator.userAgent.toLowerCase();
  var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
  if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0 || agent.indexOf("windows") >= 0) {
    //your code
    return true
  }
  if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
    //your code
    return true
  }
  if (isMac) {
    //your code
    return false
  }
}


/**
 * @desc 工具类对象
 * @param obj 对象
 * @returns true||false
 */
export const Tools = {
  isArray: function (obj) {
    return Object.prototype.toString.call(obj) === '[object Array]';
  },
  isObject: function (obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
  },
  isNumber: function (obj) {
    return Object.prototype.toString.call(obj) === '[object Number]';
  },
  isString: function (obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
  },
  isFunction: function (obj) {
    return Object.prototype.toString.call(obj) === '[object Function]';
  },
  isBoolean: function (obj) {
    return Object.prototype.toString.call(obj) === '[object Boolean]';
  },
  isNull: function (obj) {
    return obj == null || obj == '' || obj == undefined;
  },
  isNotNull: function (obj) {
    return !this.isNull(obj);
  },
  randomNum(min, max) {
    return Math.floor(min + Math.random() * (max - min));
  }
};

export const roundAll = {
  roundFn(d, n) {
    let data = d.toFixed(n);
    if (n == 1) {
      if (d.toFixed(n).split('.')[1] == 0) {
        data = d.toFixed(n).split('.')[0]
      }
    } else {
      if (d.toFixed(n).split('.')[1].substring(1) == 0) {
        if (d.toFixed(n).split('.')[1].substring(0) == 0) {
          data = d.toFixed(0);
        } else {
          data = d.toFixed(1);
        }
      } else {
        data = d.toFixed(n);
      }
    }
    return data;
  }
};

export const nowDate = {
  getNowDate() {
    let date = new Date();
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    let d = date.getDate();
    let H = date.getHours();
    let mm = date.getMinutes();
    let s = date.getSeconds()
    s = s < 10 ? "0" + s : s;
    m = m < 10 ? "0" + m : m;
    d = d < 10 ? "0" + d : d;
    H = H < 10 ? "0" + H : H;
    mm = mm < 10 ? "0" + mm : mm;
    return y +""+ m +""+ d +""+ H +""+ mm +""+ s;
    return y + "-" + m + "-" + d + " " + H + ":" + mm + ":" + s;
  }
}

export const seconds = {
  getSecond(seconds) {
    let hour = Math.floor(seconds / 3600) >= 10 ? Math.floor(seconds / 3600) : '0' + Math.floor(seconds / 3600);
    seconds -= 3600 * hour;
    let min = Math.floor(seconds / 60) >= 10 ? Math.floor(seconds / 60) : '0' + Math.floor(seconds / 60);
    seconds -= 60 * min;
    let sec = seconds >= 10 ? seconds : '0' + seconds;
    return hour + ':' + min + ':' + sec;
  }
}

export const PMSLIST = {
  "10000": {
    id: 10000,
    name: "统计",
    check: false,
    adminPms: true
  },
  "10100": {
    id: 10100,
    name: "统计-导出",
    check: false,
    adminPms: true
  },
  "20000": {
    id: 20000,
    name: "单位管理",
    check: false,
    adminPms: true
  },
  "20200": {
    id: 20200,
    name: "单位管理-新建",
    check: false,
    adminPms: true
  },
  "20300": {
    id: 20300,
    name: "单位管理-删除",
    check: false,
    adminPms: true
  },
  "20404": {
    id: 20404,
    name: "单位管理-编辑",
    check: false,
    adminPms: true
  },
  "20500": {
    id: 20500,
    name: "单位管理-详情",
    check: false,
    adminPms: true
  },
  "20501": {
    id: 20501,
    name: "单位管理-详情-新建告别厅",
    check: false,
    adminPms: true
  },
  "20502": {
    id: 20502,
    name: "单位管理-详情-删除告别厅",
    check: false,
    adminPms: true
  },
  "20503": {
    id: 20503,
    name: "单位管理-详情-修改告别厅",
    check: false,
    adminPms: true
  },
  "20504": {
    id: 20504,
    name: "单位管理-详情-新建模板",
    check: false,
    adminPms: true
  },
  "20505": {
    id: 20505,
    name: "单位管理-详情-删除模板",
    check: false,
    adminPms: true
  },
  "20506": {
    id: 20506,
    name: "单位管理-详情-修改模板",
    check: false,
    adminPms: true
  },
  "30000": {
    id: 30000,
    name: "岗位管理",
    check: false,
    adminPms: true
  },
  "30100": {
    id: 30100,
    name: "岗位管理-新建",
    check: false,
    adminPms: true
  },
  "30200": {
    id: 30200,
    name: "岗位管理-编辑",
    check: false,
    adminPms: true
  },
  "40000": {
    id: 40000,
    name: "运营帐号",
    check: false,
    adminPms: true
  },
  "40100": {
    id: 40100,
    name: "运营帐号-新建",
    check: false,
    adminPms: true
  },
  "40200": {
    id: 40200,
    name: "运营帐号-编辑",
    check: false,
    adminPms: true
  },
  "40300": {
    id: 40300,
    name: "运营帐号-停用",
    check: false,
    adminPms: true
  },
  "40400": {
    id: 40400,
    name: "运营帐号-解绑",
    check: false,
    adminPms: true
  },
  "40500": {
    id: 40500,
    name: "运营帐号-启用",
    check: false,
    adminPms: true
  },
  "40600": {
    id: 40600,
    name: "运营帐号-删除",
    check: false,
    adminPms: true
  },
  // "40700": {
  //   id: 40700,
  //   name: "运营帐号-确定用户关系",
  //   check: false,
  //   adminPms: true
  // },
  "50000": {
    id: 50000,
    name: "纪念堂管理",
    check: false,
    adminPms: true
  },
  "50104": {
    id: 50104,
    name: "纪念堂管理-全部列表-不可看",
    check: false,
    adminPms: false
  },
  "50204": {
    id: 50104,
    name: "纪念堂管理-访问码冻结列表-不可看",
    check: false,
    adminPms: false
  },
  "50304": {
    id: 50104,
    name: "纪念堂管理-纪念堂冻结列表-不可看",
    check: false,
    adminPms: false
  },
  "50400": {
    id: 50400,
    name: "纪念堂管理-新建",
    check: false,
    adminPms: true
  },
  "50500": {
    id: 50500,
    name: "纪念堂管理-预约告别厅/修改预约",
    check: false,
    adminPms: true
  },
  "50600": {
    id: 50600,
    name: "纪念堂管理-日志",
    check: false,
    adminPms: true
  },
  "50700": {
    id: 50700,
    name: "纪念堂管理-解除冻结纪念堂",
    check: false,
    adminPms: true
  },
  "50800": {
    id: 50800,
    name: "纪念堂管理-解除冻结访问码",
    check: false,
    adminPms: true
  },
  "50900": {
    id: 50900,
    name: "纪念堂管理-备注",
    check: false,
    adminPms: true
  },
  // 50900 -> 51009
  "51009": {
    id: 51009,
    name: "纪念堂管理-陵园使用",
    check: false,
    adminPms: true
  },
  "51000": {
    id: 51000,
    name: "纪念堂管理-详情",
    check: false,
    adminPms: true
  },
  "51001": {
    id: 51001,
    name: "纪念堂管理-详情-二维码预览/下载",
    check: false,
    adminPms: true
  },
  // "51002": {
  //   id: 51002,
  //   name: "纪念堂管理-详情-二维码预览",
  //   check: false
  // },
  "51003": {
    id: 51003,
    name: "纪念堂管理-详情-海报预览/下载",
    check: false,
    adminPms: true
  },
  // "51004": {
  //   id: 51004,
  //   name: "纪念堂管理-详情-海报下载",
  //   check: false
  // },
  "51010": {
    id: 51010,
    name: "纪念堂管理-详情-小程序认领码下载",
    check: false,
    adminPms: true
  },
  "51011": {
    id: 51011,
    name: "纪念堂管理-详情-App认领码下载",
    check: false,
    adminPms: true
  },
  "51012": {
    id: 51012,
    name: "纪念堂管理-详情-认领码下载",
    check: false,
    adminPms: true
  },
  "51013": {
    id: 51013,
    name: "纪念堂管理-详情-人生相册",
    check: false,
    adminPms: true
  },
  "51005": {
    id: 51005,
    name: "纪念堂管理-详情-冻结纪念堂",
    check: false,
    adminPms: true
  },
  "51006": {
    id: 51006,
    name: "纪念堂管理-详情-冻结访问码",
    check: false,
    adminPms: true
  },
  "51007": {
    id: 51007,
    name: "纪念堂管理-详情-保存/获取操作权限验证码/修改",
    check: false,
    adminPms: true
  },
  "51008": {
    id: 51008,
    name: "纪念堂管理-详情-上传",
    check: false,
    adminPms: true
  },
  "51100": {
    id: 51100,
    name: "纪念堂管理-投屏",
    check: false,
    adminPms: true
  },
  "51200": {
    id: 51200,
    name: "纪念堂管理-线下祭祀",
    check: false,
    adminPms: true
  },
  "60000": {
    id: 60000,
    name: "用户管理",
    check: false,
    adminPms: true
  },
  "60200": {
    id: 60200,
    name: "用户管理-日志",
    check: false,
    adminPms: true
  },
  // "60300": {
  //   id: 60300,
  //   name: "用户管理-详情",
  //   check: false,
  //   adminPms: true
  // },
  "60301": {
    id: 60301,
    name: "用户管理-详情-解绑",
    check: false,
    adminPms: true
  },
  "70000": {
    id: 70000,
    name: "线上订单",
    check: false,
    adminPms: true
  },
  "70200": {
    id: 70200,
    name: "线上订单-备注",
    check: false,
    adminPms: true
  },
  "70400": {
    id: 70400,
    name: "线上订单-日志",
    check: false,
    adminPms: true
  },
  "70300": {
    id: 70300,
    name: "线上订单-退款",
    check: false,
    adminPms: true
  },
  "70500": {
    id: 70500,
    name: "线上订单-下载新建纪念堂二维码",
    check: false,
    adminPms: true
  },
  "70600": {
    id: 70600,
    name: "线上订单-创建续费二维码",
    check: false,
    adminPms: true
  },
  "80000": {
    id: 80000,
    name: "APP管理",
    check: false,
    adminPms: true
  },
  "80100": {
    id: 80100,
    name: "APP管理-新建",
    check: false,
    adminPms: true
  },
  "80200": {
    id: 80200,
    name: "APP管理-编辑",
    check: false,
    adminPms: true
  },
  "80300": {
    id: 80300,
    name: "APP管理-删除",
    check: false,
    adminPms: true
  },
}



// WEBPACK FOOTER //
// ./src/utils/utils.js